module.exports = __webpack_public_path__ + "media/packs/images/state/wait-c7066471e7acec0e5f1a16475fb90156.svg";